import axios from 'axios';
import { URL_TOKEN, URL_LOGIN, appId, DOMINIO } from '../config/const';
import { notificacionError } from './alerts';
import moment from 'moment';
import { db } from '../utils/db';
import { useLiveQuery } from 'dexie-react-hooks';

let msgError = null;
export let autorizado = false;
export const axiosApi = axios.create();

//INTERCEPTORES PARA AÑADIR EL TOKEN
axiosApi.interceptors.request.use(
    async config => {
        const value = await getTokenLogin();
        config.headers = {
            'Authorization': `Bearer ${value}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
        return config;
    },
    error => {
        Promise.reject(error);
    }
);

axiosApi.interceptors.response.use((resp) => {
    return resp;
}, async (error) => {
    const status = error.response ? error.response.status : null;
    const originalRequest = error.config;
    if (status === 401) {
        autorizado = false;
        sessionStorage.removeItem("login");
        const access_token = await getTokenLogin();
        axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
        return axiosApi(originalRequest);
    }
    return Promise.reject(error);
});

//OBTENER EL TOKEN PARA INGRESAR EN EL SITIO
export const getTokenLogin = async () => {
    let data = new URLSearchParams();
    data.append("grant_type", 'client_credentials');
    data.append("client_id", 'MOBILE-APP-INVENTARIO-RAWELT-DC3B080A-BA0E-4330-B3C0-62D23F13811D');
    data.append("client_secret", '759A9EF3-6463-420B-96F3-EFDA7EF67A57');

    return await axios.post(URL_TOKEN, data)
        .then(resp => {
            return resp.data.access_token;
        })
        .catch(err => {
            return err;
        });
}

//PARA INGRESAR EN EL SITIO
export const postLogin = async (user) => {
    let data = {
        "username": user.username,
        "password": user.password,
        "applicationId": appId
    }
    return await axiosApi.post(URL_LOGIN, data)
        .then(async (resp) => {
            if (resp.data.success) {
                autorizado = true;
                sessionStorage.setItem("login", true);
                //sessionStorage.setItem("user", resp.data.user);
                sessionStorage.setItem("noEmpleado", resp.data.employeeId);
                return await getEmpleado(resp.data.employeeId)
                    .then(async empleado => {
                        if (empleado === 1) {
                            throw new Error("1 en respuesta de empleado, revisar api");
                        } else {
                            sessionStorage.setItem("user", empleado?.data?.CNUSERID.trim());
                            return resp;
                        }
                    })
                    .catch(error => {
                        console.log('errorId', error)
                        if (error.response) {
                            notificacionError(error.response.message);
                        } else if (error.request) {
                            notificacionError("Favor de comunicarse con el administrador del sistema, ERROR ONLY REQUEST en empleado");
                        } else {
                            notificacionError(error);
                        }
                    });
            } else {
                return resp;
            }
        })
        .catch(err => {
            if (err.response) {
                return err.response.message;
            } else if (err.request) {
                return "Favor de comunicarse con el administrador del sistema, ERROR ONLY REQUEST";
            } else {
                return err;
            }
            //alert("Error " + err.message);
        });
}

//OBTENER LOS PASES CON SU ENCABEZADO Y DETALLE
export const getPases = async (data = null) => {
    let user = sessionStorage.getItem("user");
    let url = null;
    if (data == null) {
        url = `${DOMINIO}GetPases?NoEmpleado=${""}&Grupo=${""}&TipoPase=${""}&Folio=${""}&FechaPaseInicial=${moment().subtract(20, "days").format('YYYY-MM-DD')}&FechaPaseFinal=${moment().add(7, 'days').format('YYYY-MM-DD')}&Autoriza=${user}&Pass`;
    } else {
        url = `${DOMINIO}GetPases?NoEmpleado=${data.empleado}&Grupo=${data.grupo}&TipoPase=${data.tipoPase}&Folio=${data.folio}&FechaPaseInicial=${data.fechaPaseInicial}&FechaPaseFinal=${data.fechaPaseFinal}&Autoriza=${user}&Pass`;
    }
    //return await axios.get(url)
    return await axiosApi.get(url)
        .then(async (resp) => {
            return resp;
        })
        .catch(err => {
            return err;
        });
}

//PARA AUTORIZAR EL PASE
export const setAutorizarPase = async (data, autoriza, pass) => {
    let url = `${DOMINIO}AutorizacionPases?NoEmpleado=${data.NoEmpleado}&TipoPase=${data.Documento}&Folio=${data.NoDocumento}&Autoriza=${autoriza}&Pass=${pass}&Grupo=${data.Grupo}`;
    //return await axios.post(url)
    return await axiosApi.post(url)
        .then(resp => {
            return resp;
        })
        .catch(err => {
            return err;
        });
}

//PARA CAMBIAR LA CONTRASEÑA
export const setCambiarContrasena = async (user, pass, newPass) => {
    let url = `${DOMINIO}CambiarPassword?Usuario=${user}&Pass=${pass}&NuevoPass=${newPass}`;
    //return await axios.post(url)
    return await axiosApi.post(url)
        .then(resp => {
            return resp;
        })
        .catch(err => {
            return err;
        });
}

//OBTENER TODOS LOS EMPLEADOS
export const getEmpleados = async () => {
    let url = `${DOMINIO}GetEmpleados`;
    //return await axios.get(url)
    return await axiosApi.get(url)
        .then(resp => {
            return resp;
        })
        .catch(err => {
            return err;
        });
}

//OBTENER UN EMPLEADO
let getEmpleadoError = 0;
export const getEmpleado = async (noEmpleado) => {
    let url = `${DOMINIO}GetIDUsuario?Empleado=${noEmpleado}`;
    //return await axios.get(url)
    return await axiosApi.get(url)
        .then(resp => {
            return resp;
        })
        .catch(err => {
            getEmpleadoError = 1
            return getEmpleadoError;
        });
}

//MENSAJES
export const msg = async (noPases) => {
    let user = sessionStorage.getItem("user"), data = null;
    let url = `https://appt.datavoice.com.mx/MediosMasivosApi/api/MediosMasivos/InsertSMSMessageResponse`;
    let config = {
        headers: {
            user: "UsrRevuelta",
            password: "R3vUelL4.SMS",
        }
    }
    await db.phones.where("user").equals(user).toArray((e) => {
        data = {
            Id: 0,
            IdApiIntegration: 42,
            Message: `BASCULAS REVUELTA SISTEMA DE PASES \n Hay ${noPases.length} pase(s) pendiente(s) por autorizar`,
            Telephone: parseInt(e[0].telefono),
            Date: new Date().getTime()
        }
    });

    return await axios.post(url, data, config)
        .then(resp => {
            return resp;
        })
        .catch(err => {
            return err;
        });
}